import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IAddOrganizationStrings extends LocalizedStringsMethods {
    lsHomeTxt: string;    
    lsOrgsTxt: string;
    lsAddTxt: string;
    lsEditTxt: string;
    lsOrgName: string;
    lsExampleTxt: string;
    lsContactFirstNameTxt: string;    
    lsContactLastNameTxt: string;
    lsContactPhoneTxt: string;
    lsContactEmailTxt: string;    
    lsAddressTxt: string;
    lsOrgEmailTxt: string;
    lsWebsiteTxt: string;
    lsAddOrgTxt: string;
    lsEditOrgTxt: string;
    lsCancelTxt: string;
    lsAddOrgSuccessTxt: string;
    lsOrgExistTxt: string;
    lsAddOrgFailedTxt: string;
    lsUpdateOrgSuccessTxt: string;
    lsUpdateOrgFailedTxt: string;
    lsSaveTxt: string;
    lsCityTxt: string;
    lsStateTxt: string;
    lsCountryTxt: string;
    lsZipPostalCodeTxt: string;
    lsSelectRegion: string;
}

let strings: IAddOrganizationStrings;
export default strings = new LocalizedStrings({
    en: {
        lsHomeTxt: 'Home',
        lsOrgsTxt: 'Organizations',
        lsAddTxt: 'Add',
        lsEditTxt: 'Edit',
        lsOrgName: 'Organization Name',
        lsExampleTxt: 'e.g.',
        lsContactFirstNameTxt: 'Organization Contact First Name',    
        lsContactLastNameTxt: 'Organization Contact Last Name',    
        lsContactPhoneTxt: 'Organization Contact Phone',
        lsContactEmailTxt: 'Organization Contact Email',    
        lsAddressTxt: 'Organization Address',
        lsOrgEmailTxt: 'Organization Email',
        lsWebsiteTxt: 'Organization Website',
        lsAddOrgTxt: 'Add Organization',
        lsEditOrgTxt: 'Edit Organization',
        lsCancelTxt: 'Cancel',
        lsAddOrgSuccessTxt: 'Organization Added Successfully',
        lsOrgExistTxt: 'Organization Already Exist',
        lsAddOrgFailedTxt: 'Failed to Add Organization',
        lsUpdateOrgSuccessTxt: 'Organization Updated Successfully',
        lsUpdateOrgFailedTxt: 'Failed to Edit Organization',
        lsSaveTxt: 'Save',
        lsCityTxt: 'Organization City',
        lsStateTxt: 'Organization State',
        lsCountryTxt: 'Organization Country',
        lsZipPostalCodeTxt: 'Organization Zip/Postal Code',
        lsSelectRegion: 'Select State'
    },
    es: {
        lsHomeTxt: 'Casa',
        lsOrgsTxt: 'Organizaciones',
        lsAddTxt: 'Añadir',
        lsEditTxt: 'Editar',
        lsOrgName: 'Nombre de la Organización',
        lsExampleTxt: 'p.ej.',
        lsContactFirstNameTxt: 'Organization Contact First Name',    
        lsContactLastNameTxt: 'Organization Contact Last Name',    
        lsContactPhoneTxt: 'Organización Contacto Teléfono',
        lsContactEmailTxt: 'Organización Contacto Correo electrónico',    
        lsAddressTxt: 'Organization Address',
        lsOrgEmailTxt: 'Organization Email',
        lsWebsiteTxt: 'Sitio web de organización',
        lsAddOrgTxt: 'Agregar organización',
        lsEditOrgTxt: 'Editar organización',
        lsCancelTxt: 'Cancelar',
        lsAddOrgSuccessTxt: 'Organización agregada con éxito',
        lsOrgExistTxt: 'La organización ya existe',
        lsAddOrgFailedTxt: 'No se pudo agregar la organización',
        lsUpdateOrgSuccessTxt: 'Organización actualizada con éxito',
        lsUpdateOrgFailedTxt: 'Failed to Edit Organization',
        lsSaveTxt: 'Save',
        lsCityTxt: 'Customer City',
        lsStateTxt: 'Customer State',
        lsCountryTxt: 'Customer Country',
        lsZipPostalCodeTxt: 'Customer Zip/Postal Code',
        lsSelectRegion: 'Select State'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/organization/string.organization.add.tsx